var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("assinaturas")]),
      _vm._v(" "),
      _c("div", { staticClass: "buttons-filters" }, [
        _c(
          "div",
          [
            _c(
              "router-link",
              { staticClass: "new-group", attrs: { to: "nova-assinatura" } },
              [
                _c("img", {
                  attrs: { src: require("../../../static/plus.svg") }
                }),
                _vm._v(" Criar pedido\n      ")
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("Pagination")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search" }, [
      _c("input", {
        staticClass: "with-icon icon-search sm",
        attrs: { type: "text", placeholder: "buscar" }
      }),
      _vm._v(" "),
      _c("button", { staticClass: "btn bg-white-purple ml-10" }, [
        _vm._v("busca avançada")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table" }, [
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("Status")]),
            _vm._v(" "),
            _c("th", [_vm._v("Tipo")]),
            _vm._v(" "),
            _c("th", [_vm._v("Dia")]),
            _vm._v(" "),
            _c("th", [_vm._v("Frequência")]),
            _vm._v(" "),
            _c("th", [_vm._v("Cliente")]),
            _vm._v(" "),
            _c("th", [_vm._v("Diarista")]),
            _vm._v(" "),
            _c("th", [_vm._v("Duração")]),
            _vm._v(" "),
            _c("th", [_vm._v("Início")]),
            _vm._v(" "),
            _c("th", [_vm._v("Endereço")]),
            _vm._v(" "),
            _c("th")
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", { staticClass: "text-center" }, [
              _c("img", {
                attrs: {
                  src: require("../../../static/icon_subscription_status_normal.svg"),
                  height: "23px"
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("B2B")]),
            _vm._v(" "),
            _c("td", [
              _c("ul", { staticClass: "day-of-week" }, [
                _c("li", [_vm._v("D")]),
                _vm._v(" "),
                _c("li", [_vm._v("S")]),
                _vm._v(" "),
                _c("li", [_vm._v("T")]),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [_vm._v("Q")]),
                _vm._v(" "),
                _c("li", [_vm._v("Q")]),
                _vm._v(" "),
                _c("li", [_vm._v("S")]),
                _vm._v(" "),
                _c("li", [_vm._v("S")])
              ])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "frequency" }, [_vm._v("semanal")])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "with-image" }, [
                _c("img", {
                  attrs: { src: require("../../../static/profile.png") }
                }),
                _vm._v(" Maria\n            ")
              ])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "with-image" }, [
                _c("img", {
                  attrs: { src: require("../../../static/profile.png") }
                }),
                _vm._v(" Maria\n            ")
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("4 horas")]),
            _vm._v(" "),
            _c("td", [_vm._v("7:00")]),
            _vm._v(" "),
            _c("td", [_vm._v("Rua das Flores, 365 - ap304")]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "btn btn-small bg-purple-outline" }, [
                _vm._v("ver mais")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", { staticClass: "text-center" }, [
              _c("img", {
                attrs: {
                  src: require("../../../static/icon_subscription_status_paused.svg"),
                  height: "23px"
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("B2B")]),
            _vm._v(" "),
            _c("td", [
              _c("ul", { staticClass: "day-of-week" }, [
                _c("li", [_vm._v("D")]),
                _vm._v(" "),
                _c("li", [_vm._v("S")]),
                _vm._v(" "),
                _c("li", [_vm._v("T")]),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [_vm._v("Q")]),
                _vm._v(" "),
                _c("li", [_vm._v("Q")]),
                _vm._v(" "),
                _c("li", [_vm._v("S")]),
                _vm._v(" "),
                _c("li", [_vm._v("S")])
              ])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "frequency" }, [_vm._v("semanal")])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "with-image" }, [
                _c("img", {
                  attrs: { src: require("../../../static/profile.png") }
                }),
                _vm._v(" Maria\n            ")
              ])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "with-image" }, [
                _c("img", {
                  attrs: { src: require("../../../static/profile.png") }
                }),
                _vm._v(" Maria\n            ")
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("4 horas")]),
            _vm._v(" "),
            _c("td", [_vm._v("7:00")]),
            _vm._v(" "),
            _c("td", [_vm._v("Rua das Flores, 365 - ap304")]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "btn btn-small bg-purple-outline" }, [
                _vm._v("ver mais")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", { staticClass: "text-center" }, [
              _c("img", {
                attrs: {
                  src: require("../../../static/icon_subscription_status_normal.svg"),
                  height: "23px"
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("B2B")]),
            _vm._v(" "),
            _c("td", [
              _c("ul", { staticClass: "day-of-week" }, [
                _c("li", [_vm._v("D")]),
                _vm._v(" "),
                _c("li", [_vm._v("S")]),
                _vm._v(" "),
                _c("li", [_vm._v("T")]),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [_vm._v("Q")]),
                _vm._v(" "),
                _c("li", [_vm._v("Q")]),
                _vm._v(" "),
                _c("li", [_vm._v("S")]),
                _vm._v(" "),
                _c("li", [_vm._v("S")])
              ])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "frequency" }, [_vm._v("semanal")])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "with-image" }, [
                _c("img", {
                  attrs: { src: require("../../../static/profile.png") }
                }),
                _vm._v(" Maria\n            ")
              ])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "with-image" }, [
                _c("img", {
                  attrs: { src: require("../../../static/profile.png") }
                }),
                _vm._v(" Maria\n            ")
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("4 horas")]),
            _vm._v(" "),
            _c("td", [_vm._v("7:00")]),
            _vm._v(" "),
            _c("td", [_vm._v("Rua das Flores, 365 - ap304")]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "btn btn-small bg-purple-outline" }, [
                _vm._v("ver mais")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", { staticClass: "text-center" }, [
              _c("img", {
                attrs: {
                  src: require("../../../static/icon_subscription_status_normal.svg"),
                  height: "23px"
                }
              })
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("B2B")]),
            _vm._v(" "),
            _c("td", [
              _c("ul", { staticClass: "day-of-week" }, [
                _c("li", [_vm._v("D")]),
                _vm._v(" "),
                _c("li", [_vm._v("S")]),
                _vm._v(" "),
                _c("li", [_vm._v("T")]),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [_vm._v("Q")]),
                _vm._v(" "),
                _c("li", [_vm._v("Q")]),
                _vm._v(" "),
                _c("li", [_vm._v("S")]),
                _vm._v(" "),
                _c("li", [_vm._v("S")])
              ])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "frequency" }, [_vm._v("semanal")])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "with-image" }, [
                _c("img", {
                  attrs: { src: require("../../../static/profile.png") }
                }),
                _vm._v(" Maria\n            ")
              ])
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "with-image" }, [
                _c("img", {
                  attrs: { src: require("../../../static/profile.png") }
                }),
                _vm._v(" Maria\n            ")
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("4 horas")]),
            _vm._v(" "),
            _c("td", [_vm._v("7:00")]),
            _vm._v(" "),
            _c("td", [_vm._v("Rua das Flores, 365 - ap304")]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "btn btn-small bg-purple-outline" }, [
                _vm._v("ver mais")
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-90918cd8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90918cd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subscription/Subscriptions.vue
// module id = null
// module chunks = 